export enum TransferDialogCloseAction {
  CLOSE = 'Close',
  CONFIRM = 'Confirm',
  FAVORITE = 'Favorite',
}
